import React from 'react';
import PropTypes from 'prop-types';
import { DetailsTable } from '@gsa/afp-component-library';


// Builds a "<name> - <code>" display value, omitting whichever part is missing.
const nameWithCode = (name, code) =>
  [name, code].filter((v) => v || v === 0).join(' - ');

// Read-only summary of a make and model (and optionally a chassis make/model)
// with their displayed codes. Shared by the approve/reject and edit modals.
const MakeModelSummary = ({
  make,
  modelName = '',
  modelCode = undefined,
  nhtsaModelCode = undefined,
  chassisMake = null,
  chassisModel = null,
}) => {
  const rows = [
    ['Make', nameWithCode(make?.makeName, make?.nhtsaMakeCode || make?.makeCode)],
    ['Model', nameWithCode(modelName, nhtsaModelCode || modelCode)],
  ];

  if (chassisMake?.makeName) {
    rows.push([
      'Chassis make',
      nameWithCode(
        chassisMake.makeName,
        chassisMake.nhtsaMakeCode || chassisMake.makeCode,
      ),
    ]);
  }

  if (chassisModel?.modelName) {
    rows.push([
      'Chassis model',
      nameWithCode(
        chassisModel.modelName,
        chassisModel.nhtsaModelCode || chassisModel.modelCode,
      ),
    ]);
  }

  return <DetailsTable data={rows} bordered />;
};

const makeShape = PropTypes.shape({
  makeName: PropTypes.string,
  makeCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nhtsaMakeCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

const modelShape = PropTypes.shape({
  modelName: PropTypes.string,
  modelCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nhtsaModelCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

MakeModelSummary.propTypes = {
  make: makeShape.isRequired,
  modelName: PropTypes.string,
  modelCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  nhtsaModelCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  chassisMake: makeShape,
  chassisModel: modelShape,
};

export default MakeModelSummary;
